exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss"), undefined);

// module
exports.push([module.id, ".HeadingAndText__section___V8RCO {\n\tflex: 1;\n\tpadding: 0 " + require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss").locals["pagePadding"] + " 1.5rem;\n\n}\n\n.HeadingAndText__itemHeadingText___2VfKE{\n    font-size: 1.2rem;\n    font-weight: normal;\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "" + require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss").locals["pagePadding"] + "",
	"section": "HeadingAndText__section___V8RCO",
	"itemHeadingText": "HeadingAndText__itemHeadingText___2VfKE"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/Item/HeadingAndText.icss
// module id = 1301
// module chunks = 0